import React, { useEffect, memo } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from '@src/components/Link';
import { SETTINGS_BILLING_ROUTE, SETTINGS_COMPANY_INFORMATION_ROUTE } from '@src/Routes/links';
import { fetchNotice } from '@src/redux/actions/notice';
import { getNotice } from '@src/redux/selectors/notice';
import { RootState } from '@src/redux/interfaces/redux.interface';
import { useAppSelector } from '@src/redux';
import { getCustomerStatus } from '@src/redux/selectors/recruiter';
import { useSessionQuery } from '@src/graphql/generated';
import { SUBSCRIPTION_PLANS } from '@src/constants';
import { canActivateFreemium } from '@src/views/CreateFunnel/util/canActivateFreemium';
import { EmailConfirmation } from './EmailConfirmation';
import { FreemiumNoticeWrapper } from './FreemiumNoticeWrapper';
import SubscriptionNoticeWrapper from './SubscriptionNoticeWrapper';
import TrialActiveNotice from './TrialActiveNotice';
import './styles.scss';

const InvoicingDetails = () => (
  <div className="frank-notice frank-notice--invoicing">
    Please fill in your invoicing details. &nbsp;
    <Link to={SETTINGS_COMPANY_INFORMATION_ROUTE}>Invoice details</Link>
  </div>
);

const PaymentFailed = () => (
  <div className="frank-notice frank-notice--payment">
    Looks like there was a payment failure. Please review your &nbsp;
    <Link to={SETTINGS_BILLING_ROUTE}>payment methods</Link>
  </div>
);

const SubscriptionInactive = () => {
  const { data: sessionData } = useSessionQuery();

  const recruiter = sessionData?.currentRecruiter;

  const { planInfo, planType } = useAppSelector(getCustomerStatus);

  return canActivateFreemium(recruiter, planInfo, planType) ? null : (
    <SubscriptionNoticeWrapper status="Your subscription is not active." />
  );
};

const FreemiumPromotion = () => {
  const { planType } = useAppSelector(getCustomerStatus);

  return planType === SUBSCRIPTION_PLANS.FREEMIUM.toLowerCase() ? <FreemiumNoticeWrapper /> : null;
};

const Notice = ({ noticeData, fetchNotice }) => {
  useEffect(() => {
    fetchNotice();
  }, []);

  const NOTICES = {
    email_confirmation: <EmailConfirmation />,
    failed_payment: <PaymentFailed />,
    invoicing_details: <InvoicingDetails />,
    subscription_inactive: <SubscriptionInactive />,
    trial_active: <TrialActiveNotice />,
    trial_ended: <SubscriptionNoticeWrapper status="Your trial has ended." />,
  };

  return NOTICES[noticeData.notice] || <FreemiumPromotion />;
};

Notice.propTypes = {
  fetchNotice: PropTypes.func.isRequired,
  notice: PropTypes.string,
};

export default connect(
  (state: RootState) => ({
    noticeData: getNotice(state),
  }),
  { fetchNotice },
)(memo(Notice));
